import { DataGrid } from '@nokia-csf-uxr/ccfk';
import { useState, useRef, useEffect } from 'react';
import { AllCommunityModules } from '@ag-grid-community/all-modules';
import { Col, Container, Row } from 'react-bootstrap';

/**
 * This file manage the budget of the dual band !
 */

/**
 * Display common information
 * @param props 
 * @returns 
 */
const DualBandLinkSummary = (props: any) => {
  let env = props.data.firstBand?.data.form;
  let link = props.data;
  let isAdvancedLink = env.pdObj.site1LatitudeValue != null;

  return <>
    <Container className="text-center" style={{fontSize: ".85rem"}}>
    <table className="table">
      <thead>
        <tr>
          <th className="col-6">Link Budget Details</th>
          <th className="col-6">User's inputs</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Link's name</td>
          <td>{props.data.firstBand?.link.name}</td>
        </tr>
        <tr>
          <td>Site 1</td>
          <td>{env.pdObj.site1Name}</td>
        </tr>
        <tr>
          <td>Site 1 additional line loss</td>
          <td>{env.clObj.site1LineMain} dB</td>
        </tr>

        { isAdvancedLink ?
        <>
        <tr>
          <td>Site 1 longitude</td>
          <td>{env.pdObj.site1LongitudeValue} {env.pdObj.site1LongitudeDirection}</td>
        </tr>
        <tr>
          <td>Site 1 latitude</td>
          <td>{env.pdObj.site1LatitudeValue} {env.pdObj.site1LatitudeDirection}</td>
        </tr>
        </>
        : <></> }
        <tr>
          <td>Site 2</td>
          <td>{env.pdObj.site2Name}</td>
        </tr>

        <tr>
          <td>Site 2 additional line loss</td>
          <td>{env.clObj.site2LineMain} dB</td>
        </tr>
        { props.advancedLink ?
        <>
        <tr>
          <td>Site 2 longitude</td>
          <td>{env.pdObj.site2LongitudeValue} {env.pdObj.site2LongitudeDirection}</td>
        </tr>
        <tr>
          <td>Site 2 latitude</td>
          <td>{env.pdObj.site2LatitudeValue} {env.pdObj.site2LatitudeDirection}</td>
        </tr>
        </>
        : <></> }
        <tr>
          <td>Path length</td>
          <td>{link.firstBand.edited_miles ? (env.pdObj.pathLength/1.609).toFixed(2) : env.pdObj.pathLength} {link.firstBand.edited_miles ? "miles" : env.pdObj.distanceUnit}</td>
        </tr>
        <tr>
          <td>Standard</td>
          <td>{env.edObj.equipmentStandard}</td>
        </tr>
        <tr>
          <td>Propagation methodology</td>
          <td>{env.coObj.multipathOutageStandard}</td>
        </tr>
        <tr>
          <td>Propagation condition</td>
          <td>{env.coObj.propagationCondition}</td>
        </tr>
        
        { isAdvancedLink ?
        <>
        <tr>
          <td>Fade factor</td>
          <td>{ Number.parseFloat( env.coObj?.fadeOccurenceFactorAuto ).toExponential(10) }</td>
        </tr>
        </>
        : <></> }
      
        <tr>
          <td>Rain outage prediction</td>
          <td>{env.coObj.rainOutageStandard}</td>
        </tr>

        <tr className={env.coObj.rainOutageStandard == "ITU.R P530" ? "" : "hide-input"}>
          <td>Rain rate</td>
          <td>{isAdvancedLink ? env.coObj.manualRainRate : env.coObj.rainRate} mm/hr</td>
        </tr>

        <tr className={env.coObj.rainOutageStandard == "ITU.R P530" && isAdvancedLink ? "" : "hide-input"}>
          <td>Rain rate standard</td>
          <td>{env.coObj.rainOutageMethod}</td>
        </tr>

        <tr className={env.coObj.rainOutageStandard == "ITU.R P530" ? "hide-input" : ""}>
          <td>Crane zone</td>
          <td>{env.coObj.craneZone}</td>
        </tr>

        <tr className={isAdvancedLink ? "" : "hide-input"}>
          <td>Annual outage methodology</td>
          <td>{env.coObj.annualOutageMethod}</td>
        </tr>

        <tr className={isAdvancedLink && env.coObj.annualOutageMethod != "itu" ? "" : "hide-input"}>
          <td>Average temperature</td>
          <td>{env.coObj.avgTempValue} {env.coObj.avgTempUnit}</td>
        </tr>

        <tr>
          <td>Field margin</td>
          <td>{env.coObj.calculationMargin} dB</td>
        </tr>

      </tbody>
    </table>  
    </Container>
  </>
}

/**
 * Resume for each band the equipment details
 * @param props 
 * - firstBand : data of the band 1
 * - secondBAnd : data of the band 2
 * @returns 
 */
const BandsSummary = (props: any) => {

  let formBand1 = props.firstBand.data.form;
  let formBand2 = props.secondBand.data.form;

  let lineTitleClass = {fontWeight: 'bold'} as any

  return <table className="table text-center" style={{fontSize: "0.85rem"}}>
  <tbody>
    <tr className="mt-2">
      <td>{props.firstBand.link.type}</td> 
      <td style={lineTitleClass}>Equipment</td>
      <td>{props.secondBand.link.type}</td> 
    </tr>

    <tr className="mt-2">
      <td>{formBand1.edObj.frequencyBand == 6.2 ? 6 : formBand1.edObj.frequencyBand} GHz</td>
      <td style={lineTitleClass}>Frequency</td>
      <td>{formBand2.edObj.frequencyBand == 6.2 ? 6 : formBand2.edObj.frequencyBand} GHz</td>
    </tr>

    <tr className="mt-2">
      <td>{formBand1.edObj.channelBandwidth} MHz</td>
      <td style={lineTitleClass}>Channel bandwidth</td>
      <td>{formBand2.edObj.channelBandwidth} MHz</td>
    </tr>

    <tr className="mt-2">
      <td>{formBand1.edObj.linkConfiguration.match(/[0-9]\+[0-9]/)[0]}</td>
      <td style={lineTitleClass}>Configuration</td>
      <td>{formBand2.edObj.linkConfiguration.match(/[0-9]\+[0-9]/)[0]}</td>
    </tr>

    {(formBand1.edObj.linkConfiguration.includes("1+1") || formBand1.edObj.linkConfiguration.includes("2+2") || formBand1.edObj.linkConfiguration.includes("4+4"))
    || (formBand2.edObj.linkConfiguration.includes("1+1") || formBand2.edObj.linkConfiguration.includes("2+2") || formBand2.edObj.linkConfiguration.includes("4+4")) ? 
    <>
    <tr className="mt-2">
      <td>{formBand1.edObj.linkConfiguration.includes("SD") ? "ON" : "OFF"}</td>
      <td style={lineTitleClass}>Space diversity</td>
      <td>{formBand2.edObj.linkConfiguration.includes("SD") ? "ON" : "OFF"}</td>
    </tr>
    </>
    :
    <></>
    }

    <tr className="mt-2">
      <td>{formBand1.edObj.linkConfiguration.includes("AP") ? "Alternate polar" : "Copolar"}</td>
      <td style={lineTitleClass}>Polarization</td>
      <td>{formBand2.edObj.linkConfiguration.includes("AP") ? "Alternate polar" : "Copolar"}</td>
    </tr>

    {formBand1.edObj.linkConfiguration.includes("AP") || formBand2.edObj.linkConfiguration.includes("AP") ?
    <>
    <tr className="mt-2">
      <td>{formBand1.edObj.linkConfiguration.includes("XPIC") ? "ON" : "OFF"}</td>
      <td style={lineTitleClass}>XPIC</td>
      <td>{formBand2.edObj.linkConfiguration.includes("XPIC") ? "ON" : "OFF"}</td>
    </tr>
    </> : <></> }
    
    <tr className="mt-2">
      <td>{formBand1.edObj.linkPolarization == "H" ? "Horizontal" : "Vertical"}</td>
      <td style={lineTitleClass}>Orientation</td>
      <td>{formBand2.edObj.linkPolarization == "H" ? "Horizontal" : "Vertical"}</td>
    </tr>

    <tr className="mt-2">
      <td>{formBand1.edObj.adaptiveModulation ? "ON" : "OFF"}</td>
      <td style={lineTitleClass}>Adaptative modulation</td>
      <td>{formBand2.edObj.adaptiveModulation ? "ON" : "OFF"}</td>
    </tr>

    {formBand1.edObj.adaptiveModulation || formBand2.edObj.adaptiveModulation ? 
    <>
      <tr className="mt-2">
        <td>{formBand1.edObj.minModulation}</td>
        <td style={lineTitleClass}>Minimum modulation</td>
        <td>{formBand2.edObj.minModulation}</td>
      </tr>
      <tr className="mt-2">
        <td>{formBand1.edObj.maxModulation}</td>
        <td style={lineTitleClass}>Maximum modulation</td>
        <td>{formBand2.edObj.maxModulation}</td>
      </tr>
    </>
    : 
    <>
      <tr className="mt-2">
        <td>{formBand1.edObj.minModulation}</td>
        <td style={lineTitleClass}>Modulation</td>
        <td>{formBand2.edObj.minModulation}</td>
      </tr>
    </>
    }

    <tr className="mt-2">
      <td>{formBand1.edObj.txPowers[0]} dBm</td>
      <td style={lineTitleClass}>TX Power</td>
      <td>{formBand2.edObj.txPowers[0]} dBm</td>
    </tr>

    <tr className="mt-2">
      <td>{formBand1.adObj.site1AntennaMain}</td>
      <td style={lineTitleClass}>{formBand1.edObj.linkConfiguration.includes("SD") || formBand2.edObj.linkConfiguration.includes("SD") ? "Site 1 main antenna" : "Site 1 antenna"}</td>
      <td>{formBand2.adObj.site1AntennaMain}</td>
    </tr>

    {formBand1.edObj.linkConfiguration.includes("SD") || formBand2.edObj.linkConfiguration.includes("SD") ?
    <>
    <tr className="mt-2">
      <td>{formBand1.adObj.site1AntennaDiv}</td>
      <td style={lineTitleClass}>Site 1 diversity antenna</td>
      <td>{formBand2.adObj.site1AntennaDiv}</td>
    </tr>
    </>
    : <></>}
    
    <tr className="mt-2">
      <td>{formBand1.adObj.site2AntennaMain}</td>
      <td style={lineTitleClass}>{formBand1.edObj.linkConfiguration.includes("SD") || formBand2.edObj.linkConfiguration.includes("SD") ? "Site 2 main antenna" : "Site 2 antenna"}</td>
      <td>{formBand2.adObj.site2AntennaMain}</td>
    </tr>

    {formBand1.edObj.linkConfiguration.includes("SD") || formBand2.edObj.linkConfiguration.includes("SD") ?
    <>
      <tr className="mt-2">
        <td>{formBand1.adObj.site2AntennaDiv}</td>
        <td style={lineTitleClass}>Site 2 diversity antenna</td>
        <td>{formBand2.adObj.site2AntennaDiv}</td>
      </tr>
    </>
    : <></>}
  </tbody>
</table>
  
}

/**
 * Generate the data grid with calculated data
 * @param props 
 * - data : serialized data to be loaded in the data grid
 * - link : data to display information behind the data grid
 * @returns 
 */
const DualBandBudget = (props: any) => {

  const [rowData, setRowData] = useState([]);

  const gridApi = useRef(null);

  const valuesUpdated = useRef(false);

  const isDualBand = useRef(!Array.isArray(props.data));

  if(valuesUpdated.current) {
    valuesUpdated.current = false;
  } else {
    setRowData(props.data)
    valuesUpdated.current = true;
  }

  const [columnDefs, setColumnDefs] = useState([
    {
      headerName: 'Band 1',
      children: [
        {
          headerName: 'Modulation',
          field: 'modulation',
          width: 100,
          cellStyle: {fontSize: '11px'}
        },
        {
          headerName: 'Capacity [Mbps]',
          field: 'capacity',
          width: 125,
          cellStyle: {fontSize: '11px'}
        },
        {
          headerName: 'Total Availability [%]',
          field: 'availability',
          width: 150,
          cellStyle: {fontSize: '11px'},
          cellRenderer: (params: any) => {
            return params.value < 0 || params.value > 100 ? "OUT of RANGE" : params.value;
          }
        },
        {
          headerName: 'Fade Margin [dB]',
          field: 'fadeMargin',
          width: 125,
          cellStyle: {fontSize: '11px'}
        }
      ],
    },
    {
        headerName: 'Band 2',
        cellStyle: {fontSize: '16px'},
        children: [
          {
            headerName: 'Modulation',
            field: 'modulation2',
            width: 100,
            cellStyle: {fontSize: '11px'}
          },
          {
            headerName: 'Capacity [Mbps]',
            field: 'capacity2',
            width: 125,
            cellStyle: {fontSize: '11px'}
          },
          {
            headerName: 'Total Availability [%]',
            field: 'availability2',
            width: 150,
            cellStyle: {fontSize: '11px'},
            cellRenderer: (params: any) => {
              // put the value in bold
              return params.value < 0 || params.value > 100 ? "OUT of RANGE" : params.value;
            }
          },
          {
            headerName: 'Fade Margin [dB]',
            field: 'fadeMargin2',
            width: 125,
            cellStyle: {fontSize: '11px'}
          }
      ],
    }
  ]);

  return (
    <>
      <DualBandLinkSummary data={props.link} />
      <Container className="mb-5 mt-5">
        <Row style={{height: "500px"}}>
          <DataGrid
            modules={AllCommunityModules}
            wrapperProps={{
              style: {
                minHeight: '400px',
                height: '100%',
                width: '100%'
              }
            }}
            columnDefs={columnDefs}
            rowData={rowData}
            suppressContextMenu
            suppressColumnMoveAnimation={true}      
            animateRows={false}
            defaultColDef={{
              menuTabs: ['filterMenuTab']
            }}
            onGridReady={(params: any) => {
              gridApi.current = params.api;
            }}
            onFirstDataRendered = {(params) => {
              params.api.sizeColumnsToFit();
            }}
          />
        </Row>
        </Container>
        <Container>
            <BandsSummary firstBand={props.link?.firstBand} secondBand={props.link?.secondBand} />
        </Container>
    </>
  );
};

export default DualBandBudget;